// Keep these instructions tied to the current UI. A saved configuration is not a deployed service.
export const featureGuides = [
  {
    key: "software", title: "소프트웨어 출시", path: "/software", group: "운영", scope: "설치형 제품 분류·등록",
    preparation: "앱 저장소, Android·Windows·iPhone 등 대상 플랫폼과 다운로드·스토어 페이지를 확인합니다.",
    steps: ["소프트웨어 등록에서 제품별 ID와 저장소를 저장합니다.", "플랫폼으로 필터링하고 다운로드 페이지를 확인합니다.", "서버와 앱이 함께 있는 저장소는 배포 대상별로 항목을 나눕니다."],
    verification: "설치형 항목은 서버 서비스 목록과 장애·Pod 집계에 포함되지 않습니다.",
    caution: "등록된 링크는 실제 파일의 빌드·서명·게시 완료를 의미하지 않습니다.",
  },
  {
    key: "release-plan", title: "무중단 배포 설계", path: "/deploy/plan", group: "운영", scope: "계획 저장·설계 검사",
    preparation: "현재 실행 대상, 복구 경로, 검증할 이미지 digest와 서비스별 관찰 기준을 준비합니다.",
    steps: ["PM2 첫 이관 또는 Kubernetes 업데이트를 선택하고 전환 방식을 정합니다.", "DB 호환·세션·파일·작업 중복·용량 조건을 확인하고 설계 검사를 실행합니다.", "관리자별 서버 저장과 버전 이력으로 계획을 보관하고 JSON으로 내보냅니다."],
    verification: "저장한 계획을 다시 불러와 판본과 입력을 확인합니다. 설계 입력 완료와 실제 서버 검증은 구분됩니다.",
    caution: "이 기능은 계획을 저장하고 전환 순서를 보여줍니다. 이미지 기동·트래픽 전환·자동복구 실행기는 연결되지 않았습니다.",
  },
  {
    key: "dashboard", title: "대시보드", path: "/", group: "운영", scope: "조회 화면",
    preparation: "로그인 후 각 카드가 어떤 자원을 집계하는지 확인합니다.",
    steps: ["카드에서 컴퓨트·스토리지·레지스트리 등 원하는 항목을 선택합니다.", "상세 화면에서 조회 시각과 오류 표시를 확인합니다."],
    verification: "카드 숫자는 해당 기능의 등록·조회 범위와 대조합니다.",
    caution: "카드의 0은 다른 서버에 자원이 없다는 뜻이 아닙니다.",
  },
  {
    key: "operations", title: "서비스 운영", path: "/operations", group: "운영", scope: "현황 조회",
    preparation: "관리자 로그인과 각 데이터 원본의 연결 상태가 필요합니다.",
    steps: ["상태등의 조회 시각·원본·오류를 먼저 확인합니다.", "미등록 실행 항목은 배포 관리에서 서비스 구성과 연결합니다."],
    verification: "등록 서비스 수와 발견된 프로세스·컨테이너 수를 별도로 확인합니다.",
    caution: "상태등은 조회된 범위의 신호이며 앱별 HTTP 건강검사를 대신하지 않습니다.",
  },
  {
    key: "deploy", title: "서비스 등록·배포", path: "/deploy", group: "운영", scope: "구성 등록 가능",
    preparation: "서비스 소스·실행 방식(PM2, Docker, Podman, Kubernetes)·대상·포트·준비검사 정보를 정합니다.",
    steps: ["새 서비스 등록에서 실행 방식과 기본 구성을 저장합니다.", "배포 대상과 개발·운영 설정을 연결하고 실행기 연결 상태를 확인합니다.", "배포 이력과 준비 상태를 확인한 뒤 운영 전환을 판단합니다."],
    verification: "등록 목록에 서비스가 보여도 실제 배포 성공 여부는 실행 이력과 대상 상태로 따로 확인합니다.",
    caution: "현재 구성 저장만으로 이미지 빌드·컨테이너 실행·자동확장이 일어나지 않습니다. 실행기와 보안 이미지 저장소 연결 전에는 배포 완료로 보지 마세요.",
  },
  {
    key: "monitor", title: "배포 모니터링", path: "/monitor", group: "운영", scope: "상태 대조",
    preparation: "배포 관리에 서비스를 먼저 등록합니다.",
    steps: ["새로고침 후 등록 서비스와 발견된 실행 항목을 구분해 봅니다.", "환경별 의도 상태·실제 상태·불일치 여부를 확인합니다."],
    verification: "대상과 조회 범위가 맞는지 확인하고, 확인 불가를 정상으로 해석하지 않습니다.",
    caution: "발견 항목은 자동 등록되지 않으며, 상태 대조는 앱 건강검사가 아닙니다.",
  },
  {
    key: "containers", title: "프로세스·컨테이너 현황", path: "/containers", group: "운영", scope: "읽기 전용",
    preparation: "관리자 권한과 운영 서버 조회 연결이 필요합니다.",
    steps: ["새로고침해 호스트별 PM2 프로세스와 API 서버의 Podman 컨테이너를 봅니다.", "직접 조회와 다른 호스트의 에이전트 자가보고를 구분합니다."],
    verification: "확인 시각·호스트·조회 실패 표시를 함께 확인합니다.",
    caution: "이 화면에서 시작·중지·배포는 하지 않으며 Podman 이벤트는 보존 기간에 따라 달라집니다.",
  },
  {
    key: "registry", title: "컨테이너 레지스트리", path: "/registry", group: "운영", scope: "이미지 등록·조회",
    preparation: "계정별 네임스페이스와 이미지 게시 권한이 필요합니다.",
    steps: ["이미지 탭에서 네임스페이스를 등록하고 화면의 저장소 주소를 확인합니다.", "그 주소로 이미지를 게시한 뒤 리포지토리·태그가 목록에 나타나는지 확인합니다.", "운영 서버 Podman 이미지와 개발 클러스터 Pod 목록은 각기 별도 범위에서 봅니다."],
    verification: "게시한 이미지의 이름·태그·조회 원본을 대조합니다.",
    caution: "이미지 목록에 보이는 것과 서비스가 배포·실행되는 것은 별개입니다. 비밀번호를 가이드나 채팅에 남기지 마세요.",
  },
  {
    key: "compute", title: "컴퓨트", path: "/compute", group: "인프라", scope: "호스트 등록",
    preparation: "관리할 호스트의 소유·접속 권한과 유형을 확인합니다.",
    steps: ["호스트 추가 또는 VPC에서 가져오기를 선택합니다.", "대상 호스트를 등록한 뒤 카드의 접속·상태 정보를 확인합니다."],
    verification: "등록 자산 수와 실제 실행 서비스 수는 서로 다르므로 각각 확인합니다.",
    caution: "호스트 등록만으로 서버를 구매하거나 서비스가 배포되지는 않습니다.",
  },
  {
    key: "network", title: "네트워크·VPC", path: "/network", group: "인프라", scope: "가상망·에이전트 등록",
    preparation: "연결할 장비를 소유하고 에이전트 설치 권한이 있어야 합니다.",
    steps: ["VPC를 만들고 가입 토큰을 발급합니다.", "해당 장비에 서버 관리 에이전트를 연결합니다.", "피어 목록에서 최근 접속과 가상 IP를 확인합니다."],
    verification: "등록 건수와 최근 접속 건수를 구분하고 연결 시각을 확인합니다.",
    caution: "가입 토큰은 비밀이며 화면 밖 문서에 붙여 넣지 마세요. 등록만으로 현재 온라인은 아닙니다.",
  },
  {
    key: "storage", title: "클라우드 스토리지", path: "/storage", group: "인프라", scope: "노드·공유 등록",
    preparation: "VPC 연결과 대상 장비의 SSH 접속 권한이 필요합니다.",
    steps: ["네트워크 드라이브에서 노드 추가를 눌러 연결 테스트 후 등록합니다.", "노드 관리에서 디스크를 확인하고 공유 이름·경로를 지정합니다.", "클라이언트에서 발급된 공유 정보로 마운트합니다."],
    verification: "노드 연결 상태, 공유 목록, 실제 마운트 결과를 각각 확인합니다.",
    caution: "연결 실패와 미확인을 공유 0개로 오인하지 마세요.",
  },
  {
    key: "kubernetes", title: "오케스트레이션", path: "/kubernetes", group: "인프라", scope: "Ansible·클러스터 조회",
    preparation: "호스트 인벤토리와 SSH 접속 권한이 필요합니다.",
    steps: ["Ansible 호스트를 추가하거나 VPC 피어를 가져옵니다.", "플레이북과 대상 호스트를 선택해 실행 결과를 확인합니다.", "개발 클러스터 Pod·노드는 별도 클러스터 화면에서 조회합니다."],
    verification: "실행 기록과 대상별 결과, 클러스터 조회 오류를 구분합니다.",
    caution: "Ansible 호스트 등록은 Kubernetes 서비스 자동배포와 다릅니다.",
  },
  {
    key: "serverless", title: "서버리스", path: "/serverless", group: "인프라", scope: "함수 등록·실행",
    preparation: "런타임과 실행 위치를 정하고, 온프레 실행이면 대상 노드의 컨테이너 런타임을 확인합니다.",
    steps: ["함수 생성에서 이름·런타임·실행 위치·핸들러를 입력합니다.", "함수 실행에 시험 이벤트를 넣고 결과·로그를 확인합니다."],
    verification: "저장 여부와 실제 실행 결과·오류를 각각 확인합니다.",
    caution: "함수 등록만으로 호출 성공을 보장하지 않습니다.",
  },
  {
    key: "database", title: "데이터베이스", path: "/database", group: "인프라", scope: "외부 DB 연결 등록",
    preparation: "접속 가능한 PostgreSQL과 필요한 연결 권한을 준비합니다.",
    steps: ["DB 연결 추가에서 외부 호스트 또는 VPC 피어를 고릅니다.", "연결 테스트 후 등록하고 상태를 다시 조회합니다."],
    verification: "등록 성공과 연결 테스트 성공을 구분해 확인합니다.",
    caution: "이 화면은 외부 DB 연결 자산용이며 스카이넷 내부 로그인 DB 목록이 아닙니다.",
  },
  {
    key: "rtremote", title: "RT Remote", path: "/rtremote", group: "인프라", scope: "원격 접속 설정",
    preparation: "접속할 PC를 VPC에 연결하고 원격 제어 권한을 확인합니다.",
    steps: ["호스트를 선택하고 화면의 연결 준비 상태를 확인합니다.", "필요한 접속 설정과 페어링을 마친 뒤 접속 결과를 확인합니다."],
    verification: "VPC 연결·스트리밍 준비·페어링·실제 접속을 따로 확인합니다.",
    caution: "접속 정보와 PIN을 가이드나 채팅에 기록하지 마세요.",
  },
  {
    key: "labs", title: "데이터레이크 설계", path: "/labs", group: "설계·계정", scope: "구성 저장",
    preparation: "연결할 VPC와 역할별 서버 관리 에이전트를 확인합니다.",
    steps: ["VPC와 역할별 피어를 선택해 구성을 저장합니다.", "저장된 역할·연결 상태를 다시 조회합니다."],
    verification: "구성 저장과 실제 서비스 설치·구동을 구분합니다.",
    caution: "이 화면은 서버 생성·구매·설치를 하지 않습니다. 견적 수치는 실측 운영비가 아닙니다.",
  },
  {
    key: "management-plan", title: "관리계획 가이드", path: "/management-plan", group: "설계·계정", scope: "자동화 계획·현황",
    preparation: "서비스의 저장소와 초기개발·시험·운영 대상을 확인합니다.",
    steps: ["자동화 계획에서 배포 흐름과 현재 연결 범위를 확인합니다.", "사용 순서에 따라 배포 관리에서 main 변경 감지와 운영 반영 범위를 설정합니다."],
    verification: "서비스별 실행기 연결, 자동 정책 사용 여부, 검증 이력을 확인합니다.",
    caution: "계획과 실제 실행 상태를 구분합니다. 자동 실행 연결 전인 서비스는 등록만으로 배포되지 않습니다.",
  },
  {
    key: "ai-services", title: "AI 설계", path: "/ai-services", group: "설계·계정", scope: "설계 설명 전용",
    preparation: "GPU·모델·게이트웨이의 목표 구성과 요구량을 검토합니다.",
    steps: ["구조·설정 항목·운영 관찰 탭에서 5계층 흐름과 지표를 살펴봅니다.", "실제 자원과 구분해 향후 연결할 설정을 정리합니다."],
    verification: "이 페이지의 예시값이 실제 노드 수치가 아님을 확인합니다.",
    caution: "입력·저장·배포·실시간 GPU 조회는 아직 연결되지 않았습니다.",
  },
  {
    key: "billing", title: "결제", path: "/billing", group: "설계·계정", scope: "잔액·결제수단",
    preparation: "충전이나 결제수단 추가 전 요금과 계정 권한을 확인합니다.",
    steps: ["잔액·사용 내역·적용 요율을 확인합니다.", "필요할 때만 결제수단 추가 또는 충전을 진행합니다."],
    verification: "거래 내역과 실제 잔액 변화를 확인합니다.",
    caution: "카드 정보나 결제 인증값을 가이드에 적지 마세요.",
  },
  {
    key: "account", title: "계정 관리", path: "/account", group: "설계·계정", scope: "프로필 관리",
    preparation: "본인 계정으로 로그인합니다.",
    steps: ["프로필에서 수정 가능한 항목을 확인합니다.", "변경 후 저장하고 다시 열어 반영 여부를 확인합니다."],
    verification: "현재 계정 표시와 저장된 프로필을 대조합니다.",
    caution: "비밀번호·토큰 원문을 지원 문의에 붙여 넣지 마세요.",
  },
  {
    key: "support", title: "고객 지원", path: "/support", group: "설계·계정", scope: "문의 등록",
    preparation: "문제 화면, 발생 시각, 안전한 오류 문구를 정리합니다.",
    steps: ["문의 등록에서 증상과 재현 단계를 적습니다.", "등록된 문의 목록에서 접수 여부를 확인합니다."],
    verification: "문의 항목이 목록에 나타나는지 확인합니다.",
    caution: "비밀키·비밀번호·전체 인증 헤더는 문의에 포함하지 마세요.",
  },
]

export function featureGuideForPath(pathname) {
  return featureGuides.find(item => item.path.toLowerCase() === pathname.toLowerCase())
}
